import PropTypes from 'prop-types';
import React from 'react';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import { Edit3, Trash } from 'react-feather';
import styled from 'styled-components';

const Handle = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    user-select: none;
    margin: -0.5rem 0.5rem -0.5rem -0.5rem;
    padding: 0.5rem;
    line-height: 1;
    border-radius: 3px 0 0 3px;
    background: #fff;
    border-right: 1px solid #ddd;
    color: #000;
    max-height: 40px;
`;

const Label = styled.div`
    align-content: flex-start;
`;

const Actions = styled.div`
    align-content: flex-end;
`;

const FormElementPresenter = ({
    editCallback,
    deleteCallback,
    item,
    dragHandleProps,
}) => {
    const { form, label, values } = item;
    const handleLabel = values && values.label ? `${values.label}` : label;
    return (
        <>
            <Handle {...dragHandleProps}>
                <svg width="24" height="24" viewBox="0 0 24 24">
                    <path
                        fill="currentColor"
                        d="M3,15H21V13H3V15M3,19H21V17H3V19M3,11H21V9H3V11M3,5V7H21V5H3Z"
                    />
                </svg>
            </Handle>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
            >
                <Grid item>{handleLabel}</Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={2}
                style={{ padding: 0 }}
            >
                {form && (
                    <Grid item>
                        <Tooltip title="Edit" placement="top">
                            <IconButton
                                style={{ padding: '5px' }}
                                onClick={() => editCallback(item)}
                            >
                                <Edit3 size={14} />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                )}
                <Grid item>
                    <Tooltip title="Delete" placement="top">
                        <IconButton
                            style={{ padding: '5px' }}
                            onClick={() => deleteCallback(item)}
                        >
                            <Trash size={14} />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
        </>
    );
};

export default FormElementPresenter;

FormElementPresenter.propTypes = {
    deleteCallback: PropTypes.func,
    dragHandleProps: PropTypes.func,
    editCallback: PropTypes.func,
    item: PropTypes.object.isRequired,
};

FormElementPresenter.defaultProps = {
    deleteCallback: () => {},
    dragHandleProps: () => {},
    editCallback: () => {},
};
